import { AsyncStoreItem } from '@lib/store';
import { CreateMycarValetResponse } from 'src/sdk-servicing';

/**
 * CreateMycarValet model
 */
export interface CreateMycarValetModel {
  model: CreateMycarValetResponse | null;
}

/**
 * CreateMycarValetResponse model details
 */
export interface CreateMycarValetStateDetails extends AsyncStoreItem {}

/**
 * CreateMycarValet store state
 */
export interface CreateMycarValetState extends CreateMycarValetStateDetails, CreateMycarValetModel {}

/**
 * Name of the CreateMycarValet Store
 */
export const CREATE_MYCAR_VALET_STORE_NAME = 'createMycarValet';

/**
 * CreateMycarValet Store Interface
 */
export interface CreateMycarValetStore {
  /** CreateMycarValet state */
  [CREATE_MYCAR_VALET_STORE_NAME]: CreateMycarValetState;
}
